export const APPLY_FILTERS = 'APPLY_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_ITEMS = 'SET_ITEMS';
export const RESET = 'RESET';
export const SET_CLIENT = 'SET_CLIENT';
export const RESET_CLIENT_STATE = 'RESET_CLIENT_STATE';
